export const getPaymentRateData =  state => state.secure.payrate.data
export const getPaymentRateLoadding = state => state.secure.payrate.isLoading

export const getGCashAccountsList = state => {
    let lists =  state.secure.gcash.list.data == undefined ? [] : state.secure.gcash.list.data
    if(lists.length % 2 === 1) {
        lists.push(undefined)
    }

    return lists;
}

export const getCashoutList = state => {
    return  state.secure.cashout.lists.data == undefined ? [] : state.secure.cashout.lists.data
}

export const getGcashAddTransMessage = state => state.secure.gcash.addtransaction.erro_msg
export const getGcashAddTransData = state => state.secure.gcash.addtransaction.data

export const coRegisterLoading = state => state.secure.cashout.register.isLoading
export const coRegisterMessage = state => state.secure.cashout.register.erro_msg
export const coRegisterData = state => state.secure.cashout.register.data


export const getCashoutHistory = state => state.secure.cashout.history.data == undefined ? [] : state.secure.cashout.history.data

export const giftCodeClaimData = state => state.secure.giftcode

export const rewardLoading = state => state.secure.reward.info.isLoading || state.secure.reward.friends.isLoading
export const rewardInfo = state => state.secure.reward.info.data
export const rewardFriends = state => state.secure.reward.friends.data
export const rewardhistoryLoading = state => state.secure.reward.history.isLoading
export const rewardHistories = state => state.secure.reward.history.data
export const rewardHistoriesInfo = state => state.secure.reward.historyInfo.data